import axios from "axios";

const URL = 'https://isolution.dev.br:8090/historico';
//const URL = 'http://localhost:8090/historico';

const api = axios.create({
    baseURL: URL
});

export default api;